"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalFormSchemaProperties = exports.InternalFormSchema = exports.InternalFormItemSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const form_schema_1 = require("./form-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.InternalFormItemSchema = zod_1.z.object({
    question: zod_1.z.string(),
    questionType: zod_1.z.string(),
    answer: form_schema_1.AnswerSchema.optional(),
    options: zod_1.z.array(zod_1.z.any()).optional(),
    min: zod_1.z.number().optional(),
    max: zod_1.z.number().optional(),
});
exports.InternalFormSchema = base_schema_1.BaseSchema.extend({
    status: form_schema_1.FormStatusEnum,
    title: zod_1.z.string().optional(),
    items: zod_1.z.array(exports.InternalFormItemSchema),
    submittedAt: zod_1.z.date().optional(),
    description: zod_1.z.string().optional(),
    memberId: zod_1.z.string(),
    clientId: zod_1.z.string().optional(),
    appointmentId: zod_1.z.string().optional(),
    templateId: zod_1.z.string(),
});
exports.InternalFormSchemaProperties = {
    collectionName: "internal_forms",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=internal-form-schema.js.map